// @flow

import * as React from "react"
import Modal from "react-modal"
import {connect} from "react-redux"
import {endOfWeek, startOfWeek, addDays, addWeeks} from "date-fns"
import {withTranslation} from "react-i18next"

import PlanningItemEditModal from "./modals/planning-item-edit"
import PlanningListItem from "./planning-list-item"
import {getPlanningItemsForRange} from "../reducers/planning"
import {markPlanningItemAsDone} from "../actions/planning"
import type {Dispatch, PlanningItem} from "../types"

type Props = {
  planningItems: $ReadOnlyArray<PlanningItem>,
  +dispatch: Dispatch,
  +showMadam: boolean,
  +readOnly: boolean,
  t: any,
}

type ModalType = "update_planning_item"

type State = {
  +isModalOpen: boolean,
  +modalType: ?ModalType,
  +modalPlanningItem: ?PlanningItem,
}

class PlanningList extends React.Component<Props, State> {
  handleMarkAsDone: (PlanningItem) => void
  handleCloseModal: () => void
  handleAfterOpen: () => void
  handleEdit: (PlanningItem) => void

  state = {
    isModalOpen: false,
    modalType: null,
    modalPlanningItem: null,
  }

  constructor(props: Props) {
    super(props)

    Modal.setAppElement("#app")

    this.handleMarkAsDone = this.handleMarkAsDone.bind(this)
    this.handleEdit = this.handleEdit.bind(this)
    this.handleCloseModal = this.handleCloseModal.bind(this)
    this.handleAfterOpen = this.handleAfterOpen.bind(this)
  }

  handleMarkAsDone(planningItem: PlanningItem) {
    const {dispatch} = this.props
    dispatch(markPlanningItemAsDone(planningItem))
  }

  handleEdit(planningItem: PlanningItem) {
    this.setState({
      modalType: "update_planning_item",
      isModalOpen: true,
      modalPlanningItem: planningItem,
    })
  }

  handleCloseModal() {
    this.setState({isModalOpen: false})
  }

  handleAfterOpen() {}

  renderModal() {
    const {isModalOpen, modalType, modalPlanningItem} = this.state
    if (!isModalOpen) {
      return null
    }
    switch (modalType) {
      case "update_planning_item":
        return (
          <PlanningItemEditModal
            handleCloseModal={this.handleCloseModal}
            handleAfterOpen={this.handleAfterOpen}
            planningItem={modalPlanningItem}
          />
        )
    }
    return null
  }

  generateKey(planningItem: PlanningItem) {
    const {babyId, key, type, id} = planningItem
    let base = "planning-list-item"
    if (babyId) {
      base = `${base}-${babyId}`
    }
    if (key) {
      base = `${base}-${key}`
    }
    if (type) {
      base = `${base}-${type}`
    }
    if (id) {
      base = `${base}-${id}`
    }
    return base
  }

  renderList(title: string, planningItems: $ReadOnlyArray<PlanningItem>) {
    if (planningItems.length === 0) {
      return null
    }
    return (
      <div className="panel mb-5">
        <h2 className="mb-3">{title}</h2>
        <ul className="planning-list">
          {planningItems.map((planningItem) => (
            <PlanningListItem
              key={this.generateKey(planningItem)}
              planningItem={planningItem}
              handleMarkAsDone={this.handleMarkAsDone}
              handleEdit={this.handleEdit}
              readOnly={this.props.readOnly}
              showMadam={this.props.showMadam}
            />
          ))}
        </ul>
      </div>
    )
  }

  render() {
    const {planningItems, t} = this.props

    const dateOpts = {weekStartsOn: 1}
    const startOfFirstWeekDate = startOfWeek(new Date(), dateOpts)
    const endOfFirstWeekDate = endOfWeek(new Date(), {weekStartsOn: 1})
    const startOfSecondWeekDate = startOfWeek(
      addDays(endOfFirstWeekDate, 1),
      dateOpts
    )
    const endOfThirdWeekDate = endOfWeek(
      addWeeks(startOfSecondWeekDate, 1),
      dateOpts
    )
    const startOfFourthWeekDate = startOfWeek(
      addDays(endOfThirdWeekDate, 1),
      dateOpts
    )
    const endOfSeventhWeekDate = endOfWeek(
      addWeeks(startOfFourthWeekDate, 3),
      dateOpts
    )
    const startOfEigthWeekDate = startOfWeek(
      addDays(endOfSeventhWeekDate, 1),
      dateOpts
    )
    const end = new Date(2100, 1, 1)

    return (
      <>
        {this.renderModal()}
        {this.renderList(
          t("dashboard.planning.group1"),
          getPlanningItemsForRange(
            planningItems,
            startOfFirstWeekDate,
            endOfFirstWeekDate,
            true
          )
        )}
        {this.renderList(
          t("dashboard.planning.group2"),
          getPlanningItemsForRange(
            planningItems,
            startOfSecondWeekDate,
            endOfThirdWeekDate
          )
        )}
        {this.renderList(
          t("dashboard.planning.group3"),
          getPlanningItemsForRange(
            planningItems,
            startOfFourthWeekDate,
            endOfSeventhWeekDate
          )
        )}
        {this.renderList(
          t("dashboard.planning.group4"),
          getPlanningItemsForRange(planningItems, startOfEigthWeekDate, end)
        )}
      </>
    )
  }
}

export default withTranslation()(connect()(PlanningList))
